module.exports = __webpack_public_path__ + "img/plan3_book02.c7fcc0e4.png";